{
  "loading": "Yükleniyor…",
  "placeholder": "Bir seçim yapın…"
}